import React from "react";
import { DISPLAY_LOG_LEVELS, ServiceMessagingService } from "../../../constants";
import { Card, MenuItem, Select } from "@material-ui/core";
import { ServiceLogLevelResponse } from "../../../models/Administration";
import { DateDisplay } from "../../DateDisplay";
import { hasPowFeature, POW_FEATURES } from "../../../services/powFeatures.service";

export interface ServiceLogLevelDisplayProps {
	// The name of the service to render
	service: ServiceLogLevelResponse;
	// callback method for setting the new log level for the service.
	setLogLevel: (serviceName: string, logLevel: string) => void;
	// boolean indicating whether or not the service has been updated locally.
	updated: boolean;
}

/**
 * Displays a single service and its log level
 */
export const ServiceLogLevelDisplayCard = ({ service, setLogLevel, updated }: ServiceLogLevelDisplayProps) => {
	return (
		<Card style={{ margin: "20px", padding: "10px" }}>
			<div style={{ display: "flex", justifyContent: "space-between" }}>
				<div>
					<h4 style={{ fontStyle: updated ? "italic" : "normal" }}>
						{ServiceMessagingService[service.serviceName]} {updated && "*"}
					</h4>
					<div
						style={{
							fontSize: 12,
							paddingBottom: "20px",
						}}
					>
						Updated By: {service.updatedBy}
					</div>
				</div>
				<div
					style={{
						marginLeft: 6,
						float: "right",
						fontSize: 12,
						paddingTop: 4,
						justifyContent: "flex-end",
						paddingLeft: 6,
						paddingBottom: 10,
					}}
				>
					Last Updated: <DateDisplay date={service.updatedDate} fontSize={12} />
				</div>
			</div>
			{(hasPowFeature(POW_FEATURES.pdpAdminServiceLogLevels_Edit) && (
				<div>
					<Select
						value={service.logLevel}
						onChange={(event) => setLogLevel(service.serviceName, event.target.value as string)}
					>
						{Object.keys(DISPLAY_LOG_LEVELS).map((level) => (
							<MenuItem value={DISPLAY_LOG_LEVELS[level]} key={level}>
								{level}
							</MenuItem>
						))}
					</Select>
				</div>
			)) || (
				<>
					<h6>Log Level:</h6>
					<div>{service.logLevel}</div>
				</>
			)}
		</Card>
	);
};
